export default name =>
    name ? name.replace(/\\/g, "/").replace(/.*\//, "") : null
